<div *ngIf="insertionForm" [formGroup]="insertionForm">
  <div class="row">
    <div class="mb-3 text-secondary col-12 col-xl-6">
      <label>Entrepreneur</label>
      <select class="form-select" formControlName="entrepreneur">
        <option value=""></option>
        <option *ngIf="insertionForm.controls.entrepreneur.value" [ngValue]="insertionForm.controls.entrepreneur.value">
          {{ EntrepreneurLabel[insertionForm.controls.entrepreneur.value] }}
        </option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <label class="required">Situation au moment de la demande de RSJ :</label>
    </div>
  </div>
  <div class="mt-2 ps-0" formArrayName="rsjSituations">
    <ng-container *ngFor="let rsjSituation of rsjSituations.controls; index as i">
      <div class="row mb-2" [formGroupName]="i">
        <div class="col-12 col-lg-6 mb-2">
          <select class="form-select" formControlName="situationId" [class.is-invalid]="submitted && rsjSituations.controls[i]?.invalid">
            <option [ngValue]=""></option>
            <option [ngValue]="situation.id" *ngFor="let situation of filterSituations(i)">
              {{ situation.label }}
            </option>
          </select>
        </div>
        <div class="col-12 col-lg-6 mb-lg-2">
          <div class="input-group">
            <input type="text" class="form-control rounded" formControlName="situationComment" placeholder="Commentaire ..." />
            <button
              *ngIf="i > 0"
              type="button"
              class="btn btn-outline-primary ms-3 rounded"
              ngbTooltip="Supprimer"
              placement="left"
              (click)="removeSituation(i)"
              [disabled]="disabled"
            >
              <fa-icon icon="trash-alt"></fa-icon>
            </button>
            <button
              *ngIf="i === 0"
              type="button"
              class="btn btn-primary ms-3 rounded"
              ngbTooltip="Ajouter"
              placement="left"
              (click)="addNewSituation()"
              [disabled]="disabled"
            >
              <fa-icon icon="plus"></fa-icon>
            </button>
          </div>
        </div>
        <small *ngIf="submitted && rsjSituations.controls[i]?.invalid" class="form-text text-danger ms-3">Ce champ est requis.</small>
      </div>
    </ng-container>
  </div>
  <div class="row mt-3">
    <div class="col-12 mb-3">
      <div class="form-check">
        <input
          id="outOfEducationSystem"
          type="checkbox"
          class="form-check-input"
          formControlName="outOfEducationSystem"
          name="outOfEducationSystem"
          [class.is-invalid]="submitted && insertionForm.controls.outOfEducationSystem.invalid"
        />
        <label for="outOfEducationSystem" class="form-check-label"
          ><strong>Je déclare sur l'honneur ne pas être étudiant, ni lycéen, ni collégien et ne pas percevoir de bourses</strong
          ><span class="text-danger"> *</span></label
        >
        <small *ngIf="submitted && insertionForm.controls.outOfEducationSystem.errors?.required" class="form-text text-danger"
          >Ce champ est requis.</small
        >
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p>
        <strong> Suivi social </strong>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="mb-3 col-12 col-lg-5">
      <label class="required">Suivi social en cours</label>
      <div class="row justify-content-start my-2">
        <div class="col-3">
          <div class="form-check form-check-inline">
            <input
              id="socialCareInProgressYes"
              type="radio"
              class="form-check-input"
              formControlName="socialCareInProgress"
              name="socialCareInProgress"
              [class.is-invalid]="submitted && insertionForm.controls.socialCareInProgress.invalid"
              [value]="true"
            />
            <label for="socialCareInProgressYes" class="form-check-label">Oui</label>
          </div>
        </div>
        <div class="col-3">
          <div class="form-check form-check-inline">
            <input
              id="socialCareInProgressNo"
              type="radio"
              class="form-check-input"
              formControlName="socialCareInProgress"
              name="socialCareInProgress"
              [class.is-invalid]="submitted && insertionForm.controls.socialCareInProgress.invalid"
              [value]="false"
            />
            <label for="socialCareInProgressNo" class="form-check-label">Non</label>
          </div>
        </div>
      </div>
      <small *ngIf="submitted && insertionForm.controls?.socialCareInProgress?.errors?.required" class="form-text text-danger"
        >Ce champ est requis.</small
      >
    </div>
    <div class="mb-3 col-12 col-lg-5">
      <label>Nom de la structure de suivi :</label>
      <input type="text" class="form-control" formControlName="socialStructureName" />
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="required float-start">Suivi service ASE entre 17-18 ans ?</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="aseServiceYes"
          type="radio"
          class="form-check-input"
          formControlName="aseService"
          name="aseService"
          [class.is-invalid]="submitted && insertionForm.controls.aseService.invalid"
          [value]="true"
        />
        <label for="aseServiceYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="aseServiceNo"
          type="radio"
          class="form-check-input"
          formControlName="aseService"
          name="aseService"
          [class.is-invalid]="submitted && insertionForm.controls.aseService.invalid"
          [value]="false"
        />
        <label for="aseServiceNo" class="form-check-label">Non</label>
      </div>
    </div>
    <small *ngIf="submitted && insertionForm.controls?.aseService?.errors?.required" class="form-text text-danger ms-3">Ce champ est requis.</small>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start">Si oui, sur le territoire de la Métropole de Lyon ?</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input id="aseServiceLyonYes" type="radio" class="form-check-input" formControlName="aseServiceLyon" name="aseServiceLyon" [value]="true" />
        <label for="aseServiceLyonYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input id="aseServiceLyonNo" type="radio" class="form-check-input" formControlName="aseServiceLyon" name="aseServiceLyon" [value]="false" />
        <label for="aseServiceLyonNo" class="form-check-label">Non</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <label class="required">Dispositif déjà mobilisé au cours du parcours :</label>
    </div>
  </div>
  <div class="mt-2 ps-0" formArrayName="rsjMobilizedPlans">
    <div class="row" *ngFor="let rsjMobilizedPlan of rsjMobilizedPlans.controls; index as i">
      <div class="mb-3 col-12 col-lg-6">
        <div class="input-group">
          <select class="form-select rounded" [formControlName]="i" [class.is-invalid]="submitted && i == 0 && rsjMobilizedPlans.invalid">
            <option [ngValue]=""></option>
            <option [ngValue]="mobilizedPlan.id" *ngFor="let mobilizedPlan of filterMobilizedPlans(i)">
              {{ mobilizedPlan.label }}
            </option>
          </select>
          <button
            *ngIf="i > 0"
            type="button"
            class="btn btn-outline-primary ms-3 rounded"
            ngbTooltip="Supprimer"
            placement="left"
            (click)="removeMobilizedPlan(i)"
            [disabled]="disabled"
          >
            <fa-icon icon="trash-alt"></fa-icon>
          </button>
          <button
            *ngIf="i === 0"
            type="button"
            class="btn btn-primary ms-3 rounded"
            ngbTooltip="Ajouter"
            placement="left"
            (click)="addNewMobilizedPlan()"
            [disabled]="disabled"
          >
            <fa-icon icon="plus"></fa-icon>
          </button>
        </div>
        <small *ngIf="submitted && i === 0 && rsjMobilizedPlans.invalid" class="form-text text-danger">Ce champ est requis.</small>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p>
        <strong> Éléments statistiques </strong><br />
        <small class="text-secondary">Informations à visée statistique n'ayant pas d'incidence sur l'accès au RSJ.</small>
      </p>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap text-secondary">
    <div class="col-12 col-lg-5">
      <label class="float-start">Couverture santé</label>
    </div>
    <div class="col-12 col-lg-5">
      <select class="form-select" formControlName="healthInsurance">
        <option value=""></option>
        <option *ngIf="insertionForm.controls.healthInsurance.value" [ngValue]="insertionForm.controls.healthInsurance.value">
          {{ insertionForm.controls.healthInsurance.value.label }}
        </option>
      </select>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start">Complémentaire santé :</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="complementaryHealthYes"
          type="radio"
          class="form-check-input"
          formControlName="complementaryHealth"
          name="complementaryHealth"
          [value]="true"
        />
        <label for="complementaryHealthYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="complementaryHealthNo"
          type="radio"
          class="form-check-input"
          formControlName="complementaryHealth"
          name="complementaryHealth"
          [value]="false"
        />
        <label for="complementaryHealthNo" class="form-check-label">Non</label>
      </div>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start">Avez-vous renoncé à des soins au cours des 6 derniers mois ?</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="givenUpCareInPast6MonthsYes"
          type="radio"
          class="form-check-input"
          formControlName="givenUpCareInPast6Months"
          name="givenUpCareInPast6Months"
          [value]="true"
        />
        <label for="givenUpCareInPast6MonthsYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="givenUpCareInPast6MonthsNo"
          type="radio"
          class="form-check-input"
          formControlName="givenUpCareInPast6Months"
          name="givenUpCareInPast6Months"
          [value]="false"
        />
        <label for="givenUpCareInPast6MonthsNo" class="form-check-label">Non</label>
      </div>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start">Accès internet individuel</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="individualInternetAccessYes"
          type="radio"
          class="form-check-input"
          formControlName="individualInternetAccess"
          name="individualInternetAccess"
          [value]="true"
        />
        <label for="individualInternetAccessYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="individualInternetAccessNo"
          type="radio"
          class="form-check-input"
          formControlName="individualInternetAccess"
          name="individualInternetAccess"
          [value]="false"
        />
        <label for="individualInternetAccessNo" class="form-check-label">Non</label>
      </div>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start">Êtes-vous relié au réseau TCL depuis votre domicile ?</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="connectedToTCLNetworkYes"
          type="radio"
          class="form-check-input"
          formControlName="connectedToTCLNetwork"
          name="connectedToTCLNetwork"
          [value]="true"
        />
        <label for="connectedToTCLNetworkYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="connectedToTCLNetworkNo"
          type="radio"
          class="form-check-input"
          formControlName="connectedToTCLNetwork"
          name="connectedToTCLNetwork"
          [value]="false"
        />
        <label for="connectedToTCLNetworkNo" class="form-check-label">Non</label>
      </div>
    </div>
  </div>
  <div class="row mb-3 d-flex flex-row align-items-center flex-wrap">
    <div class="col-12 col-lg-5">
      <label class="float-start">Accès loisirs/divertissement/culture au cours des 12 derniers mois ?</label>
    </div>
    <div class="col-12 col-lg-7">
      <div class="form-check form-check-inline">
        <input
          id="leisureAccessInPast12MonthsYes"
          type="radio"
          class="form-check-input"
          formControlName="leisureAccessInPast12Months"
          name="leisureAccessInPast12Months"
          [value]="true"
        />
        <label for="leisureAccessInPast12MonthsYes" class="form-check-label">Oui</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          id="leisureAccessInPast12MonthsNo"
          type="radio"
          class="form-check-input"
          formControlName="leisureAccessInPast12Months"
          name="leisureAccessInPast12Months"
          [value]="false"
        />
        <label for="leisureAccessInPast12MonthsNo" class="form-check-label">Non</label>
      </div>
    </div>
  </div>
</div>
